<!-- TipsSwitch.svelte -->

<script>
  /** Props */
  let {
    active = $bindable(false),
    icon = "", // Default empty for SVG
    iconPath = "", // Path to SVG icon
    tooltip = "", // Tooltip text
    backgroundColor = "#bff2ef", // Default teal color for active state
    id = "",
    ontoggle = () => {},
  } = $props();

  let showTooltip = $state(false);

  function toggle() {
    active = !active;
    ontoggle(active);
  }
</script>

<div class="tooltip-container" 
     onmouseenter={() => showTooltip = true}
     onmouseleave={() => showTooltip = false}
     onfocusin={() => showTooltip = true}
     onfocusout={() => showTooltip = false}
     role="button"
     tabindex="-1"
>
  <button 
    class="tips-button"
    class:active
    onclick={toggle}
    aria-pressed={active}
    style="--active-bg: {backgroundColor}"
    aria-label={tooltip || (active ? 'Hide help' : 'Show help')}
  >
    {#if iconPath}
      <img 
        src={iconPath} 
        class="svg-icon" 
        alt="" 
        aria-hidden="true"
      />
    {:else if icon}
      <span class="icon">{icon}</span>
    {/if}
  </button>

  {#if tooltip && showTooltip}
    <div class="tooltip">
      {tooltip}
    </div>
  {/if}
</div>

<style>
  .tooltip-container {
    position: relative;
    display: inline-block;
  }

  .tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 0.5em 0.75em;
    border-radius: 4px;
    font-size: 0.875rem;
    white-space: nowrap;
    margin-bottom: 8px;
    z-index: 100;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    pointer-events: none;
  }

  .tooltip:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
  }

  .tips-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5em 1em;
    margin: 0 0.25em;
    border: 1px solid #ccc;
    border-radius: 10px;
    background-color: #ffffff;
    color: #363636;
    cursor: pointer;
    font-size: 1rem;
    height: 2.25em;
    line-height: 1.5;
    position: relative;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease, transform 0.1s ease;
  }

  .tips-button:hover {
    border-color: #999;
    color: #363636;
  }

  .tips-button:active {
    transform: scale(0.98);
  }

  .tips-button.active {
    background-color: var(--active-bg, #bff2ef);
    border-color: transparent;
    color: rgba(0, 0, 0, 0.7);
  }

  .svg-icon {
    width: 1.3em;
    height: 1.3em;
    line-height: 1;
    user-select: none;
    filter: grayscale(100%) contrast(0.5) brightness(0.7);
    transition: filter 0.2s ease;
    object-fit: contain;
  }

  .icon {
    width: 1.3em;
    height: 1.3em;
    line-height: 1;
    user-select: none;
    font-size: 1.3em;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .active .svg-icon {
    filter: grayscale(100%) contrast(1) brightness(0.3);
  }

  /* Focus styles for accessibility */
  .tips-button:focus-visible {
    outline: 2px solid #4a90e2;
    outline-offset: 2px;
  }


</style>
